import React, { useState, useEffect } from "react";

import shopify from "frontend/js/shopify";

export default function InventoryDetail({ variantId }) {
  const [isHomeDeliveryAvailable, setIsHomeDeliveryAvailable] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchInvetoryDetails() {
      setIsLoading(true);

      const response = await shopify.getInventoryDetails([variantId]);
      const inventoryLevels = response?.data?.nodes[0]?.inventoryItem?.inventoryLevels?.nodes || []

      if (inventoryLevels?.length) {
        const combinedStore = inventoryLevels.find(inventorylevel => inventorylevel.location.name === "Combined Store");

        if (combinedStore && combinedStore.quantities[0]?.quantity > 0) {
          setIsHomeDeliveryAvailable(true);
        }
      }

      setIsLoading(false);
    }

    fetchInvetoryDetails();
  }, [])

  if (isLoading || isHomeDeliveryAvailable) return;

  return (
    <p className="blabel text-[#D12727] mt-1">
      Unavailable for delivery
    </p>
  );
}
